var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactIcon = function SvgContactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6FFE3",
    d: "M18 2.882v18.236A2.884 2.884 0 0 1 15.118 24H2.882A2.884 2.884 0 0 1 0 21.118V2.882A2.884 2.884 0 0 1 2.882 0h12.236A2.884 2.884 0 0 1 18 2.882m-1.687 16.056V2.881c0-.658-.537-1.195-1.195-1.195H2.882c-.658 0-1.195.537-1.195 1.195v16.056l1.38-.062.87-3.552a.6.6 0 0 1 .591-.465h2.245a3.66 3.66 0 0 1-1.697-3.118c0-2.087 1.633-3.678 3.804-3.678s3.846 1.591 3.846 3.678-.642 2.466-1.686 3.118h2.244c.285 0 .518.19.591.465l.87 3.552zm-6.329 2.53a1.03 1.03 0 1 0-2.061 0 1.03 1.03 0 0 0 2.061 0"
  })));
};
export default SvgContactIcon;